/* global mtt_search_obj, console, jQuery */

import GA4Tracking from 'app/GA4/utils/ga4-tracking'

/**
 * Define the search bar and search area.
 * Setup the search bar and search area, if the exists on the page.
 *
 * @constructor
 */
const MTTSearch = function () {
  if (typeof this.mtt_search_ajax === 'undefined') {
    this.mtt_search_ajax = {} // This object will keep track of ajax status
  }

  this.ajax_url = mtt_search_obj.ajax_url
  this.rest_url = mtt_search_obj.rest_url
  this.bar_form = jQuery('form[' + mtt_search_obj.bar.selector + ']')
  this.area_form = jQuery('form[' + mtt_search_obj.area.selector + ']')
  this.firstTimeLoad = true
  if (this.bar_form.length > 0) {
    this.setupBar()
  }
  if (this.area_form.length > 0) {
    this.setupArea()
  }
}

/**
 * Setup bar, where it defines the search input, the wrapper and the result.
 * Makes an event if the input is changed.
 */
MTTSearch.prototype.setupBar = function () {
  this.bar_post_types = this.bar_form.find('[data-post_type]')
  this.bar_input = this.bar_form.find('[type="search"]')
  this.bar_result_wrapper = this.bar_form.find('.result-wrapper')
  this.bar_result = this.bar_form.find('.result')
  this.bar_form.on('input', this.debounce(this.onBarChange.bind(this), 1000))
  jQuery(document).on('mousedown', this.onClick.bind(this))
}

/**
 * Shows the wrapper and show the loading icon.
 * Makes a Ajax call with the search string.
 *
 * @param e
 */
MTTSearch.prototype.onBarChange = function (e) {
  e.preventDefault()
  if (this.bar_input.val().length === 0) {
    this.toggleSearchWrapper(true)
    this.bar_result.html('')
    return
  }
  this.toggleLoading(this.bar_result_wrapper)
  this.toggleSearchWrapper()
  const data = {
    post_types: this.getPostTypes(this.bar_post_types),
    search_string: this.bar_input.val()
  }
  this.ajax('prima/search/bar', data, this.onBarAjaxCallback.bind(this))
}

/**
 * Check if there is an event, that is outside the bar_result_wrapper
 *
 * @param e
 */
MTTSearch.prototype.onClick = function (e) {
  if (this.bar_form && !jQuery(e.target).closest(this.bar_form).length) {
    this.toggleSearchWrapper(true)
  }
}

/**
 * Return from the Ajax call, where it remove the loading icon.
 * Changes the search result with the new result.
 *
 * @param response
 */
MTTSearch.prototype.onBarAjaxCallback = function (response) {
  this.toggleLoading(this.bar_result_wrapper, true)
  this.bar_result.html(response.data.html)
}

/**
 * Setup area, where it defines the inputs, the result and the pagination.
 * It defines the page number.
 * Makes an event if the input is changed and when the page is loaded.
 */
MTTSearch.prototype.setupArea = function () {
  this.search_slug = this.area_form.find('input[name="search_slug"]').val()
  this.base_url = this.area_form.find('input[name="base_url"]').val()
  this.area_post_types = this.area_form.find('[data-post_type]')
  this.category = this.area_form.find('[data-product_cat]')
  this.area_input = this.area_form.find('[type="search"]')
  this.area_taxonomies = this.area_form.find('[data-taxonomy]')
  this.area_posts_per_page = this.area_form.find('[name="posts_per_page"]')
  this.area_products = this.area_form.find('.products')
  this.area_pages = []
  this.area_pages.push(parseInt(this.area_form.find('[name="page_number"]').val()))
  this.area_current_page = this.getStartPage()
  this.area_max_page = parseInt(this.area_form.find('input[name="area_max_page"]').val())
  this.setupPagination()

  if (mtt_search_obj.use_filter === 'true') {
    this.setupFilter()
    this.setupMobileFilter()
    this.addFilterToggles()
  }

  jQuery(window).load(this.onAreaPageLoad.bind(this))
  this.area_form.on('change', this.debounce(this.onAreaChange.bind(this), 1000))
}

/**
 * Setup the pagination, where it defines the the pagination to previous products and more products.
 */
MTTSearch.prototype.setupPagination = function () {
  this.area_pagination_prev = jQuery('.products-wrapper').find('.mtt-pagination.prev')
  this.area_pagination_next = jQuery('.products-wrapper').find('.mtt-pagination.next')
  this.area_pagination_progress_count_prev = jQuery('.progress-count-prev')
  this.area_pagination_indicator_prev = jQuery('.progress-indicator-prev')
  this.area_pagination_load_prev = jQuery('[name="load-prev"]')
  if (this.area_current_page !== 1) {
    this.area_pagination_load_prev.on('click', this.onAreaLoadPrev.bind(this))
    this.area_pagination_prev.removeClass('hide')
  }
  this.area_pagination_progress_count = jQuery('.progress-count')
  this.area_pagination_indicator = jQuery('.progress-indicator')
  this.area_pagination_load_more = jQuery('[name="load-more"]')
  this.area_pagination_load_more.on('click', this.onAreaLoadMore.bind(this))
}

/**
 * Setup the sidebar filters, so that you can hide them.
 */
MTTSearch.prototype.setupFilter = function () {
  const filterItem = document.querySelectorAll('.filter-item')
  const fl = jQuery(filterItem).length
  for (let i = 0; i < fl; i++) {
    jQuery(filterItem[i]).on('click', '.title', function () {
      const parent = jQuery(this).parent('.filter-item')

      if (parent.hasClass('filter-item-active')) {
        parent.removeClass('filter-item-active')
      } else {
        parent.addClass('filter-item-active')
      }
    })
  }
}

/**
 * Setup mobile sidebar filters.
 */
MTTSearch.prototype.setupMobileFilter = function () {
  if (document.querySelector('.mtt-filter-mobile')) {
    jQuery('.mtt-filter-mobile__trigger').on('click', open)
    jQuery('.close-filter').on('click', close)
    jQuery('#product-navigation-toggle').on('click', close)
    jQuery('.mtt-filter-topbar__button.clear-filter').on('click', close)
  }

  function open () {
    jQuery('#navigation-toggle').addClass('hide')
    jQuery('#product-navigation-toggle').addClass('show')
    jQuery('.mtt-filter-topbar__items').addClass('show')
    setTimeout(() => {
      jQuery('#product-navigation-toggle').addClass('open')
    }, 100)
  }

  function close () {
    jQuery('.mtt-filter-topbar__items').removeClass('show')
    jQuery('#product-navigation-toggle').removeClass('open')
    setTimeout(() => {
      jQuery('#navigation-toggle').removeClass('hide')
      jQuery('#product-navigation-toggle').removeClass('show')
    }, 500)
  }
}

/**
 * Get the start page number from mtt_search_obj.
 *
 * @returns number
 */
MTTSearch.prototype.getStartPage = function () {
  if (mtt_search_obj.params.page) {
    return parseInt(mtt_search_obj.params.page)
  }
  return 1
}

/**
 * Returns the post_type.
 *
 * @param formClass
 * @returns {{post_types: []}}
 */
MTTSearch.prototype.getPostTypes = function (formClass) {
  const postTypes = []
  formClass.each(function () {
    postTypes.push(jQuery(this).data('post_type'))
  })
  return postTypes
}

/**
 * Add page number to the area_pages.
 *
 * @param pageNumber
 */
MTTSearch.prototype.addPage = function (pageNumber) {
  this.area_pages.push(pageNumber)
  this.area_pages.sort()
}

/**
 * Returns the highest page number that has been loaded.
 *
 * @returns number
 */
MTTSearch.prototype.getMaxLoadedPage = function () {
  return this.area_pages[this.area_pages.length - 1]
}

/**
 * Returns the lowest page number that has been loaded.
 *
 * @returns number
 */
MTTSearch.prototype.getLowestLoadedPage = function () {
  return this.area_pages[0]
}

/**
 * Toggle the loading icon on the area_form.
 * Makes a Ajax call with the inputs.
 */
MTTSearch.prototype.doSearch = function (currentPage) {
  this.toggleLoading(this.area_form)

  const taxonomies = this.generateTaxonomiesObject()
  if (taxonomies[Object.keys(mtt_search_obj.queried_param)[0]] === undefined) {
    taxonomies[Object.keys(mtt_search_obj.queried_param)[0]] = [Object.values(mtt_search_obj.queried_param)[0]]
  }
  const data = {
    post_types: this.getPostTypes(this.area_post_types),
    search_string: this.area_input.val(),
    taxonomies: taxonomies,
    posts_per_page: this.area_posts_per_page.val(),
    page: currentPage,
    post_id: document.body.getAttribute('data-post-id'),
    is_product_cat: document.body.className.indexOf('tax-product_cat') !== -1
  }

  if (mtt_search_obj.queried_param.hasOwnProperty('product_cat')) {
    data.product_cat = mtt_search_obj.queried_param.product_cat
  }

  this.ajax('prima/search/products', data, this.onAreaAjaxCallback.bind(this))
}

/**
 * Called when an input is changed.
 *
 * @param e
 */
MTTSearch.prototype.onAreaChange = function (e) {
  e.preventDefault()
  this.area_pages = []
  this.doSearch(1)
}

/**
 * Called when the load more button is clicked.
 *
 * @param e
 */
MTTSearch.prototype.onAreaLoadMore = function (e) {
  e.preventDefault()
  if ((this.getMaxLoadedPage() + 1) <= this.area_max_page) {
    this.doSearch(this.getMaxLoadedPage() + 1)
  }
}

/**
 * Called when the load prev button is clicked.
 *
 * @param e
 */
MTTSearch.prototype.onAreaLoadPrev = function (e) {
  e.preventDefault()
  if ((this.getLowestLoadedPage() - 1) >= 1) {
    this.doSearch(this.getLowestLoadedPage() - 1)
  }
}

/**
 * Return from the Ajax call, where it remove the loading icon.
 * Changes the search result with the new result.
 * Set's the area_current_page and adds the page to the area_pages.
 *
 * @param response
 */
MTTSearch.prototype.onAreaAjaxCallback = function (response) {
  this.handleGA4Items(jQuery(response.html), response.page)
  this.toggleLoading(this.area_form, true)
  this.area_max_page = response.pages
  if (this.area_pages.length === 0) {
    this.area_products.html(response.html)
  } else {
    if (this.area_current_page > parseInt(response.page)) {
      this.area_products.prepend(response.html)
    } else {
      this.area_products.append(response.html)
    }
  }
  this.area_current_page = parseInt(response.page)
  this.addPage(parseInt(response.page))
  this.updatePagination(response.found_posts, response.pagination_type, this.area_pages.length === 1)
  if (mtt_search_obj.use_filter === 'true') {
    this.onAreaPageLoad()
    this.buildAndPushState()
  }
}

/**
 * Get all the loaded products.
 * Check if the found_posts is 0.
 * Sets the pagination html and width of the indicator.
 * Check if all the products has been loaded.
 * Check if the lowest area_pages is loaded.
 *
 * @param foundPosts
 * @param paginationType
 */
MTTSearch.prototype.updatePagination = function (foundPosts, paginationType, newSearch) {
  let shown = this.area_form.find('.products li').not('.product-ad').length
  let indicator = 100 / foundPosts * shown
  if (foundPosts === 0) {
    shown = 0
    indicator = 0
  }

  let progress_text = mtt_search_obj.strings.you_have_seen
  progress_text = progress_text.replace('%s1', shown).replace('%s2', foundPosts).replace('%s3', paginationType)

  this.area_pagination_progress_count_prev.html(progress_text)
  this.area_pagination_indicator_prev.css('width', indicator + '%')
  this.area_pagination_progress_count.html(progress_text)
  this.area_pagination_indicator.css('width', indicator + '%')
  if (shown === foundPosts || this.getMaxLoadedPage() === this.area_max_page) {
    this.area_pagination_load_more.html(mtt_search_obj.strings.no_more)
    this.area_pagination_load_more.addClass('disabled')
  } else {
    this.area_pagination_load_more.html(mtt_search_obj.strings.load_more)
    this.area_pagination_load_more.removeClass('disabled')
  }
  if (this.getLowestLoadedPage() === 1) {
    this.area_pagination_load_prev.html(mtt_search_obj.strings.no_prev)
    this.area_pagination_load_prev.addClass('disabled')
  } else {
    this.area_pagination_load_prev.html(mtt_search_obj.strings.load_prev)
    this.area_pagination_load_prev.removeClass('disabled')
  }

  if (newSearch) {
    this.area_pagination_prev.addClass('hide')
    this.area_pagination_next.removeClass('hide')
  }
}

MTTSearch.prototype.onAreaPageLoad = function () {
  let urlParameters = ''
  if (this.firstTimeLoad) {
    this.firstTimeLoad = false
    urlParameters = Object.assign({}, this.generateTaxonomiesObject(), this.getURLParameters())
  } else {
    urlParameters = this.generateTaxonomiesObject()
  }
  for (let i = 0; i < this.area_taxonomies.length; i++) {
    const inputField = jQuery(this.area_taxonomies[i])
    if (urlParameters[inputField.data('taxonomy')] === undefined) continue
    if (!urlParameters[inputField.data('taxonomy')].includes(inputField.val())) continue
    inputField.prop('checked', true)
  }
  this.buildAndPushState()
}

/**
 * Add or removes the search bar wrapper.
 *
 * @param off
 */
MTTSearch.prototype.toggleSearchWrapper = function (off = false) {
  if (off) {
    this.bar_result_wrapper.hide()
    this.bar_result.html('')
    return
  }
  this.bar_result_wrapper.show()
}

/**
 * Add or removes the loading class and add or removes the loader element.
 *
 * @param formClass
 * @param off
 */
MTTSearch.prototype.toggleLoading = function (formClass, off = false) {
  if (off) {
    formClass.removeClass('loading')
    formClass.find('.loader').remove()
    return
  }
  formClass.addClass('loading')
  formClass.append(this.generateHTML('div', 'loader'))
}

/**
 * Returns all the taxonomy options that have been selected.
 *
 * @returns []
 */
MTTSearch.prototype.generateTaxonomiesObject = function () {
  const taxonomies = {}
  const tl = this.area_taxonomies.length
  for (let i = 0; i < tl; i++) {
    const element = jQuery(this.area_taxonomies[i])
    const taxonomy = element.data('taxonomy')
    if ((element.is(':checkbox') && !element.is(':checked')) || element.val() === '-1' || taxonomy === 'order') {
      continue
    }
    if (taxonomies[taxonomy] === undefined) {
      taxonomies[taxonomy] = []
    }
    taxonomies[taxonomy].push(element.val())
  }

  return taxonomies
}

MTTSearch.prototype.getURLParameters = function () {
  const pageUrl = window.location.search.substring(1)
  const urlVariables = pageUrl.split('&')
  const taxonomies = {}
  for (let i = 0; i < urlVariables.length; i++) {
    if (urlVariables[i] === '') continue
    const splittedParamater = urlVariables[i].split('=')
    if (splittedParamater[0] === 'page' || splittedParamater[0] === 'order') continue
    const splittedParamaterValues = splittedParamater[1].split(',')
    for (let j = 0; j < splittedParamaterValues.length; j++) {
      if (taxonomies[splittedParamater[0].replace('filter-', '')] === undefined) {
        taxonomies[splittedParamater[0].replace('filter-', '')] = []
      }
      taxonomies[splittedParamater[0].replace('filter-', '')].push(splittedParamaterValues[j])
    }
  }
  for (let i = 0; i < Object.keys(mtt_search_obj.params).length; i++) {
    if (Object.keys(mtt_search_obj.params)[i] === 'page' || Object.keys(mtt_search_obj.params)[i] === 'order') continue
    if (taxonomies[Object.keys(mtt_search_obj.params)[i]] !== undefined) continue

    taxonomies[Object.keys(mtt_search_obj.params)[i].replace('filter-', '')] = ['' + Object.values(mtt_search_obj.params)[i]]
  }

  return taxonomies
}

/**
 * Generate the url with the taxonomy options and push it to the url.
 */
MTTSearch.prototype.buildAndPushState = function () {
  if (window.history.pushState) {
    let taxonomies = {}
    if (this.firstTimeLoad) {
      this.firstTimeLoad = false
      taxonomies = Object.assign({}, this.generateTaxonomiesObject(), this.getURLParameters())
    } else {
      taxonomies = this.generateTaxonomiesObject()
    }

    let searchParams = ''
    let pageParam = ''
    if (this.getMaxLoadedPage() !== 1) {
      pageParam = this.search_slug + '/' + this.getMaxLoadedPage().toString() + '/'
    }

    for (const [key, value] of Object.entries(taxonomies)) {
      if (key === 'product_cat' || key === 'order') {
        continue
      }

      if (searchParams !== '') {
        searchParams += '&'
      }

      searchParams += 'filter-' + key + '=' + value.join(',')
    }

    searchParams = searchParams !== '' ? '?' + searchParams : ''
    const modifiedUrl = this.base_url + pageParam + searchParams
    window.history.pushState({ path: modifiedUrl }, '', modifiedUrl)
  }
}

/**
 *
 *
 * @param data
 * @param callback
 */
MTTSearch.prototype.ajax = function(endpoint, data, callback) {
  if (typeof this.mtt_search_ajax[endpoint] === 'undefined') {
    this.mtt_search_ajax[endpoint] = null // If no request have been made yet using this ajax_id, then set default
  }
  this.mtt_search_ajax[endpoint] = jQuery.ajax({
    method: 'GET',
    url: this.rest_url + endpoint,
    data: data,
    beforeSend: () => {
      if (this.mtt_search_ajax[endpoint] != null) {
        this.mtt_search_ajax[endpoint].abort()
      }
    }
  }).done(callback).fail(callback)
}

/**
 * Debounce function, that let you set a wait time before an function need to be called.
 *
 * @param func
 * @param wait
 * @param immediate
 * @returns {function(...[*]=)}
 */
MTTSearch.prototype.debounce = function (func, wait, immediate) {
  let timeout

  return function () {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) func.apply(context, args)
  }
}

/**
 * Generate html.
 *
 * @param tag
 * @param classes
 * @param innerHTML
 * @returns {string}
 */
MTTSearch.prototype.generateHTML = function (tag, classes = '', innerHTML = '') {
  if (classes) {
    classes = " class='" + classes + "'"
  }
  return '<' + tag + classes + '>' + innerHTML + '</' + tag + '>'
}

MTTSearch.prototype.addFilterToggles = function () {
  const that = this

  // close filter item when clicking outside
  const FILTER_ITEMS = jQuery('.mtt-filter-topbar__items .filter-item')
  jQuery(document).mouseup(function (e) {
    if (!FILTER_ITEMS.is(e.target) && FILTER_ITEMS.has(e.target).length === 0) {
      FILTER_ITEMS.removeClass('show')
    }
  })

  // show filter item
  jQuery(document).on('click', '.mtt-filter-topbar__items .filter-item__name', function () {
    jQuery(this).parent().toggleClass('show').siblings().removeClass('show')
  })

  // clear filter
  jQuery(document).on('click', '.mtt-filter-topbar__button.clear-filter', function (e) {
    e.preventDefault()

    // remove all "checked" from inputs
    jQuery('.filter-item input[type="checkbox"]:not([data-taxonomy="order"])').each(function () {
      jQuery(this).prop('checked', false)
    })

    // update area form
    that.onAreaChange(e)
  })
}

MTTSearch.prototype.handleGA4Items = function (markup, page) {
  // Handle GA4 'view_item_list'
  const startIndex = (parseInt(page) - 1) * parseInt(this.area_posts_per_page.val())
  const gaItemElements = markup.find('[data-ga-item]')
  let gaData = JSON.parse(this.area_products.attr('data-ga-data'))
  let items = []

  delete gaData.start_index

  gaItemElements.each(index => {
    const gaItem = JSON.parse(jQuery(gaItemElements[index]).attr('data-ga-item'))
    gaItem.index = index + startIndex
    items.push(gaItem)
  })

  GA4Tracking.pushEvent('view_item_list', items, gaData)
}

if (jQuery('form[' + mtt_search_obj.bar.selector + ']').length >= 0 || jQuery('form[' + mtt_search_obj.area.selector + ']').length >= 0) {
  window.mtt_search = new MTTSearch()
}
